import {ability} from '@/libs/acl/ability';
import store from '@/store';
import { tabIndexMaper } from './userManagementHelper';

export function canViewRoute(to, from, next){
  if(!to.meta.requiresAuth){
    next();
  }else{
    const requiredAction = to.meta.action;
    const requiredResource = to.meta.resource;
    let hasPermission = ability.can(requiredAction, requiredResource);
    const tabIndex = to.query.tabIndex;

    if(!hasPermission){
      console.warn(`Permission denied: User tried to access ${to.name} with action "${requiredAction}" on subject "${requiredResource}"`);
      return next({name: 'error-401'});
    }else{
      if(tabIndex || tabIndex == 0){
      const tabPermission = tabIndexMaper(to, tabIndex);
        if(tabPermission && tabPermission.status){
          return next();
        }
        else{
          var newTabIndex = Number(tabIndex) + 1;
          while(newTabIndex < tabPermission.maxTabs){
            let nextTab = tabIndexMaper(to, newTabIndex)
            if(nextTab.status){
              return next({
                name: to.name,
                query: {tabIndex: nextTab.currentTab}
              })
            }else{
              newTabIndex++;
            }
          }
          if(newTabIndex >= tabPermission.maxTabs){
            return next({name:'error-401'});
          }
        }
      }else{
        return next();
      }
    }
  }
 

}